/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SchulformInputs */

const de__field_schulform = /** @type {(inputs: _Field_SchulformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schulform`)
};

/**

* @param {_Field_SchulformInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_schulform = /** @type {((inputs?: _Field_SchulformInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SchulformInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schulform(inputs)
});